<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col>
          <span class="float-left text-warning">
            Can more scroll : {{model.length | number}} / {{so.totalRows | number}}
          </span>
          <br>
          <span v-if="so.totalRows <= model.length" class="float-left text-danger">
            All loaded result
          </span>
        </b-col>
        <b-col>
          <b-form-group>
            <b-form>
            <label for="opt_date">From </label>
              <date-picker v-model="From" :lang="lan" :first-day-of-week="1" @change="load(true)"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <b-form>
            <label for="opt_date">To </label>
              <date-picker v-model="To" :lang="lan" :first-day-of-week="1" @change="load(true)"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="text-center">
          <p>
            <c-switch style="" color="danger" label size="sm" v-model="status" text="Danger" @change="load(true)"/>
          </p>
          Status : only see danger site
        </b-col>
        <b-col>
          <!-- 레이아웃용 -->
        </b-col>
      </b-row>
      <b-row v-if="model.length">
        <b-col sm="12">
          <b-progress :value="model.length" :max="so.totalRows" variant="warning" striped :animated="true" class="mt-2"></b-progress>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row>
        <b-col sm="6">
          <label for="ph_search_groupname">Group Name</label>
          <b-button variant="primary" @click="chainGroup = true">Select Group</b-button>
          <b-form-group>
            <b-form-input @keydown.enter="load(true)" type="text" :disabled="false" v-model="opt.group_name">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <label for="ph_search_fqdn">Site FQDN</label>
          <b-form-group>
            <b-form-input @keydown.enter="load(true)" type="text" :disabled="false" v-model="opt.site_fqdn">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button size="sm" variant="warning" block @click="clear">Clear</b-button>
    </b-card>
    <hr>
    <div @scroll="scroll"  ref="_result_list" :style="`min-height:300px; max-height:800px;overflow-y:scroll;`">
      <b-row v-if="model.length">
        <item v-for="(item, index) in model" :key="index" :item="item" :index="index" @click="select"></item>
      </b-row>
      <b-card v-if="model.length || loading" class="w-100 text-center">
        <i v-if="loading" class="fa fa-refresh fa-spin"></i>
        <span v-else>End</span>
      </b-card>
      <b-card v-else class="text-center">
        <span>No have Checked Sites </span>
      </b-card>
      <!-- 레이아웃 조정용 -->
      <p ref="offset" v-if="$refs._result_list" :style="`margin-top:${800 - $refs._result_list.clientHeight}`"> </p>
    </div>
    <hr>
    <router-view @refresh="refresh()"></router-view>

    <!-- start modal -->
    <b-modal title="Find then Group and Select" size="xl"  header-bg-variant="info" v-model="chainGroup" @ok="chainGroup = false" ok-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
    <b-modal title="Detail of result" size="xl"  header-bg-variant="info" v-model="detail" ok-only @ok="detail = false" ok-variant="primary">
      <more :item="item"></more>
    </b-modal>
  </div>
</template>

<script>
import More from './Result.More';
import Item from './Result.Grid';
import datepicker from '@/custom';
import DatePicker from 'vue2-datepicker';
import { Api } from '@/service';
import moment from 'moment-timezone'
import { Switch as cSwitch } from '@coreui/vue';
import groupList from '../../Management/group/Group.List'

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  offset : 0,
  limit : 10,
  sk : '', sv : '', skt : ''
})

export default {
  components: {
    cSwitch,
    DatePicker,
    Item,
    groupList,
    More
  },
  data: () => {
    return {
      opt : {
        site_fqdn : '',
        group_name : '',
        group_id : '',
      },
      detail : false,
      chainGroup : false,
      status : false,
      loading : false,
      item : undefined,
      lan: datepicker,
      From: '',
      To: '',
      model : [],
      so : {
        totalRows: 0,
        offset : 0,
        limit : 10,
        perPage : 10
      },
    }
  },
  methods: {
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.opt.group_id = item.id;
      this.opt.group_name = item.groupname
      this.chainGroup = false;
      this.load(true)
    },
    select(item) {
      this.item = item;
      this.detail = true;
      console.log(item.site.fqdn)
    },
    scroll() {
      let div = this.$refs._result_list;
      // console.log("load", div.clientHeight + div.scrollTop, div.scrollHeight)
      if(this.so.limit >= this.so.totalRows ) { return location.hostname == "" ? console.log("all", 'load') : ''; }
      if(div.clientHeight + div.scrollTop < div.scrollHeight) { return location.hostname == "" ? console.log("check", 'length') : ''; }
      if(this.so.totalRows <= this.model.length) { return this.$toastr.s("done", "all load result") }
      // start real load
      this.$toastr.i("load", "waitting more load site")

      this.so.offset = this.model.length > 0 ? this.so.offset + this.so.limit : this.so.offset;

      // this.so.offset += this.model.length > 0 this.so.limit;
      this.so.limit = this.so.perPage;
      if (!this.loading) { this.load(); }
    },
    clear() { this.opt = { group_id : '', group_name : '', site_fqdn : '' }; this.load(true) },
    reset() { this.so = default_opt(); this.model = []; this.refresh(); },
    refresh() { console.log("refresh") },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    load(reset = false){
      if(reset) { this.reset(); }
      this.loading = true
      let and = [
        { name : 'finished_at', value : moment(this.From), op : '>='},
        { name : 'finished_at', value : moment(this.To), op : '<'}
      ]
      if(this.status) { and.push({ name : 'detect_count', value : 0, op : '>'}) }
      if(this.opt && this.opt.group_id) { and.push({ name : 'group_id', value : parseInt(this.opt.group_id), op : '='}) }
      if(this.opt && this.opt.site_fqdn) { and.push({ name : 'site.fqdn', value : this.opt.site_fqdn, op : 'like'}) }
      // console.log(and, "and")
      let so = {
        target : 'wmds.result', cmd : 'list',
        body : { sort : [{ name : 'id', op : 'desc'}], or : [], and : and },
        offset : this.so.offset, limit : this.so.limit,
      }

      Api.Manager(so)
        .then(rs => {
          this.so.totalRows = rs.total;
          if(rs.body)
          {
            for (let i = 0; i < rs.body.length; i++) { this.model.push(rs.body[i]); }
          }
        })
        .then(() => {
          // console.log("done", "offset", this.so.offset, "limit", this.so.limit, "total", this.so.totalRows)
          this.so.totalRows > this.model.length && this.$toastr.s(`load more, left ${this.so.totalRows - this.model.length}`, "done")
          if(this.$refs._result_list) {
            this.$refs._result_list.scrollTop += 30;
            let h = this.$refs._result_list.clientHeight;
            this.$refs.offset.style.marginTop = `${810 - h}px`;
          }
        })
        .then(() => this.loading = false)
        .catch(e => { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText)});
    },
  },
  created() { console.log('result.vue', 'created'); },
  destroyed() { console.log('result.vue', 'destroyed'); },
  mounted() {
    console.log('result.vue', 'mounted');
    this.From = location.hostname == "localhost" ? moment().add(-1, 'M').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    this.To = moment().format('YYYY-MM-DD');
    this.load();
  },
}
</script>
